import styled from 'styled-components';
import { dynamicStyles, h6Styles } from 'utils/resuable-css';

export const BgLogin = styled.div`
  width: 100%;
  min-height: 100vh;
`;

export const FirstStep = styled.div`
  width: 100%;
  padding: 18px 20px;
  border-bottom: 2px solid ${(props) => props.theme.primaryDarkColor};
  @media only screen and (max-width: 1440px) {
    padding: 15px;
  }
`;

export const FlexFirst = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  background: ${(props) => props.theme.secondaryColor};
  z-index: 999;
  position: fixed;
  right: 0;
  left: ${(props) => props.theme.default?.desktop_menu_width};
  ${(props) => dynamicStyles(props.theme.resolutions, 'desktop_menu_width', 'left')};
  padding: 5px 20px 15px 20px;
  transition: all 0.5s ease;
  @media only screen and (max-width: 1280px) {
    left: 0;
  }
  .ticketAndusername {
    h6 {
      margin: 0;
      margin-top: 15px;
      margin-right: 10px;
      font-weight: bold;
      color: white;
    }
  }
`;

export const SecondStep = styled.div`
  width: 100%;
  padding: 18px 20px;
  @media only screen and (max-width: 1440px) {
    padding: 15px;
  }
`;

export const Buttons = styled.div`
  display: flex;
  @media only screen and (max-width: 960px) {
    flex-wrap: wrap !important;
  }
`;
export const TwoWindows = styled.div`
  display: flex;
  margin: 1.5em 0;
  width: 100%;
  margin-top: 5em;
  @media only screen and (max-width: 1440px) {
    margin-top: 4em;
    margin-bottom: 0;
  }
  @media only screen and (max-width: 960px) {
    flex-wrap: wrap;
  }
  @media only screen and (max-width: 930px) {
    margin-top: 7em;
  }
  @media only screen and (max-width: 678px) {
    margin-top: 10em;
  }
  @media only screen and (max-width: 395px) {
    margin-top: 13em;
  }
`;

export const Errors = styled.div`
  margin: 1.5em 0;
`;

export const PurpleError = styled.div`
  display: flex;
  justify-content: center;
  background: #8552da;
  margin-bottom: 10px;
  align-items: center;
  padding: 1em;
  border-radius: 5px;

  h6 {
    margin: 0;
    color: white;
    font-weight: bold;
  }
  i {
    margin-right: 10px;
    font-size: 18px;
    color: white;
  }
`;

export const GreenError = styled.div`
  display: flex;
  justify-content: center;
  background: green;
  margin-bottom: 10px;
  align-items: center;
  padding: 1em;
  border-radius: 5px;

  h6 {
    margin: 0;
    color: white;
    font-weight: bold;
  }
  i {
    margin-right: 10px;
    font-size: 18px;
    color: white;
  }
`;

export const RedError = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: red;
  margin-bottom: 10px;
  padding: 1em;
  border-radius: 5px;
  p {
    margin: 0;
    color: white;
    font-size: 16px;
    font-weight: bold;
  }
  i {
    margin-right: 10px;
    font-size: 18px;
    color: white;
  }
`;

export const ChatLogContainer = styled.div`
  padding: 1em;
  display: flex;
  width: 100%;
`;

export const WidthDiv = styled.div`
  width: 22em;
  @media only screen and (max-width: 900px) {
    display: none !important;
  }
`;

export const Content = styled.div`
  width: 100%;
  margin-left: 72px;
  @media only screen and (max-width: 900px) {
    margin-left: 43px;
  }
`;

export const Heading = styled.div`
  display: flex;
  margin-bottom: 1em;
  i {
    margin-right: 5px;
    margin-top: 3px;
  }
  .heading {
    margin: 0;
  }
`;

export const TicketNotFound = styled.h6`
  font-size: ${(props) => props.theme.default?.h6};
  ${(props) => h6Styles(props.theme.resolutions)};
  font-weight: bold;
  text-align: center;
  width: 100%;
  padding: 2em 0;
`;
